<template>
  <div>
    <div class="container-scroller" style="background: #f9fafb">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="spinner"
      ></loading>
      <cookie-law theme="blood-orange--rounded"></cookie-law>
      <AuthWrapper @new_language="updateLang">
        <template slot="content">
          <div style="bottom: 0; width: 100%" class="right-form">
            <div class="col-12">
              <div class="card-background">
                <div>
                  <h2 class="text-center sign-in mb-3">{{ $t("sign-in") }}</h2>
                  <h5 class="text-center font-14 gray4 mb-1">
                    {{ $t("welcome") }}
                  </h5>
                </div>
                <div
                  v-if="mssg"
                  class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
                >
                  <p class="alert-close mb-0">
                    {{ mssg }}
                  </p>
                </div>
                <form @submit.prevent="onSubmit" class="pt-3">
                  <div class="form-group">
                    <label for="InputEmail">{{ $t("email") }}</label>
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        id="InputEmail"
                        required="required"
                        v-model="email"
                        name="email"
                      />
                    </div>
                  </div>
                  <div class="form-group position-relative">
                    <label for="InputPassword">{{ $t("password") }} </label>
                    <div class="form-group position-relative">
                      <input
                        :type="isVisible ? 'text' : 'password'"
                        class="form-control"
                        id="InputPassword"
                        required="required"
                        v-model="password"
                        name="password"
                      />
                      <div
                        class="position-absolute mb-4 mr-2"
                        style="cursor: pointer; top: 0.8rem; right: 0.5rem"
                      >
                        <div v-if="isVisible" @click="isVisible = !isVisible">
                          <i class="fas fa-eye"></i>
                        </div>
                        <div v-else @click="isVisible = !isVisible">
                          <i class="far fa-eye-slash"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="my-3">
                    <button
                      type="submit"
                      class="btn btn-primary w-100"
                      style="border-radius: 5px"
                    >
                      {{ $t("login") }}
                    </button>
                  </div>
                  <div class="text-right pt-3">
                    <p>
                      <router-link
                        to="/forgotpassword"
                        class="btn-link font-14 font-weight-light"
                        >{{ $t("fgt-pwd") }}
                      </router-link>
                    </p>
                  </div>
                </form>

                <!-- <div>
                  <p class="mt-0 p-1 text-center font-14">
                    {{ $t("acc") }}
                    <router-link class="text-primary" to="/signup"
                      >{{ $t("signup") }}
                    </router-link>
                  </p>
                </div> -->
              </div>
            </div>
          </div>
        </template>
      </AuthWrapper>
      <!-- page-body-wrapper ends -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import CookieLaw from "vue-cookie-law";
import vClickOutside from "v-click-outside";
import AuthWrapper from "./AuthWrapper.vue";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      mssg: "",
      isLoading: false,
      fullPage: true,
      isVisible: false,
      language: "EN",
      show_drop: false,
      show_drop_mobile: false,
    };
  },
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    Loading,
    CookieLaw,
    AuthWrapper,
  },
  methods: {
    ...mapActions(["login"]),
    onSubmit() {
      this.isLoading = true;
      var user = {
        email: this.email.toLowerCase(),
        password: this.password,
      };
      this.login(user)
        .then((res) => {
          if (res.data.success) {
            this.$router.push("/");
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.mssg = error.response.data.message;
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    hideDrop() {
      this.show_drop = false;
    },
    hideDropMobile() {
      this.show_drop_mobile = false;
    },
    updateLang(lang) {
      this.$emit("new_language", lang);
    },
  },
};
</script>

<style scoped>
.Cookie--batman {
  background: #f1f1f1;
  color: #232323;
  padding: 1.25em;
}
.Cookie--batman .Cookie__button {
  cursor: pointer;
  align-self: center;
  white-space: nowrap;
  color: #fff;
  background-color: #213e7a;
  border-color: #213e7a;
  border-radius: 20px;
  line-height: 1;
  font-weight: 400;
}

.Cookie--batman .Cookie__content {
  color: yellow;
}
/* .Cookie--batman {
  background: black;

  > .Cookie__button {
      background: black;
      color: yellow;
  }

  > .Cookie__content {
    color: yellow;
  }
} */
.visible-append {
  cursor: pointer;
}
.left-column {
  /* padding: 0 3rem 1rem; */
  padding: 0 1rem 1rem 5rem;
  /* padding: 0 1rem 1rem 5rem; */
  place-items: flex-start;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.left-column p {
  color: #5e6a79;
  font-family: Sarabun;
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 140.62%;
}

.left-column h1 {
  line-height: 1.2;
  font-weight: bolder;
  color: #212529;
  font-size: 2.75rem;
}
.left-column .d-block {
  z-index: 3;
}
.img-green {
  position: absolute;
  top: 0;
  left: 0;
  height: 90vh;
  z-index: 1;
}
.page-body-wrapper.full-page-wrapper {
  width: 100%;
  min-height: 100vh;
  padding-top: 0;
  max-width: 35rem;
}
.row-login {
  position: absolute;
  width: 100%;
  bottom: 0;
}
.lang {
  float: right;
  position: relative;
  top: 4rem;
}
/* .left-column .d-block {
  position: relative;
  top: 50%;
} */
.dropdown-lang {
  background: #ffffff;
  border: 0.3px solid rgba(99, 99, 99, 0.25);
  box-shadow: 0px 20px 50px rgba(29, 53, 71, 0.06);
  border-radius: 3px;
  z-index: 1000 !important;
  top: 2rem;
  color: #5e6a79;
  width: calc(100% - 1.5rem);
}
input[type="radio"] {
  border: 1px solid green !important;
}
input[type="radio"]:checked {
  background-color: red !important;
  /* width: calc(100% - 1.5rem); */
}
input[type="radio"] {
  accent-color: green !important;
}
.radio-btn {
  border: 1px solid red !important;
}
.hover-item {
  padding: 8px;
}
.hover-item:hover {
  background-color: #f6f8f9;
}
.gricd-logo {
  /* position: absolute;
  top: 3rem;
  height: 5rem;
  z-index: 3; */

  position: absolute;
  top: 5rem;
  height: 4rem;
  z-index: 3;
  left: 0rem;
}

.card-background {
  background: #ffffff;
  box-shadow: 0px 4px 10px rgba(138, 142, 148, 0.05);
  border-radius: 10px;
  padding: 2rem 1.5rem;
}

@media (max-width: 576px) {
  .img-green {
    height: 50vh;
    width: calc(100% - 10rem);
  }
  .left-column h1 {
    margin-top: 5rem;
    font-size: 2rem;
  }
  .gricd-logo {
    /* position: absolute;
    top: 2rem;
    height: 2rem;
    z-index: 3;
    left: -1rem; */
    position: absolute;
    top: 1rem;
    height: 2rem;
    z-index: 3;
    left: 0rem;
  }
  .hide-lang {
    display: none !important;
  }
  .mobile-lang {
    top: 2.6rem;
    margin-left: auto;
    z-index: 10;
  }
  .left-column {
    /* padding: 0 3rem 1rem; */
    padding: 0 3rem 1rem 3rem;
    place-items: flex-start;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
  }
  .vh-100 {
    height: auto !important;
  }
  .page-body-wrapper.full-page-wrapper {
    min-height: auto;
  }
}
@media (max-width: 1250px) and (min-width: 900px) {
  .gricd-logo {
    position: absolute;
    top: 3rem;
    height: 3rem;
    z-index: 3;
    left: 0;
    /* left: 2rem; */
  }
}

@media (max-width: 2100px) and (min-width: 1680px) {
  .gricd-logo {
    position: absolute;
    /* top: 7rem; */
    height: 5rem;
    z-index: 3;
    left: 0;
    /* left: 4rem; */
  }
  .left-column {
    padding: 0 1rem 1rem 5rem;
  }
  .left-column h1 {
    line-height: 1.2;
    font-weight: bolder;
    color: #212529;
    /* font-size: 3.75rem; */
    font-size: 3.4rem;
  }
  .left-column p {
    color: #5e6a79;
    font-family: Sarabun;
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 140.62%;
  }
  .img-green {
    position: absolute;
    top: 0;
    left: 0;
    height: 88vh;
    z-index: 1;
  }
  .right-form {
    flex-grow: 1;
    display: flex;
    align-items: end;
  }

  .right-form .col-12 {
    display: flex;
    flex-flow: column;
    /* width: 100%; */
    height: 100%;
    justify-content: center;
  }

  .right-form .col-12 .auth-form-transparent {
    width: 100% !important;
    height: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-evenly;
  }
  .page-body-wrapper.full-page-wrapper {
    width: 100%;
    min-height: 100vh;
    padding-top: 0;
    max-width: 39rem;
  }
  .brand-logo img {
    height: 4rem;
  }
  h5 {
    font-size: 1.2rem;
  }
  .auth form .form-group label {
    font-size: 1.05rem;
  }
  .auth .brand-logo {
    margin-bottom: 0;
  }
  p {
    font-size: 1.05rem;
  }
  .btn {
    font-size: 1.2rem;
  }
  .small {
    font-size: 0.875rem;
  }
  .sign-in {
    font-size: 24px;
    font-weight: 700;
    color: #282828;
  }
}
</style>

<i18n>
{
	"en": {
		"acc": "Don't have an account?",
		"change-lang": "Change Language",
		"email": "E-mail",
		"fgt-pwd": "Forgot Password?",
		"login": "Login",
		"password": "Password",
		"real-time": "With real-time data-backed decisions.",
		"scale": "Scale your Operation and",
		"scale-2": "increase profitability",
		"signup": "Sign Up",
		"welcome": "Welcome back! Please login to your account.",
		"zero-stress": "No stress, zero hassle.",
    "sign-in":"Sign In"
	},
	"es": {
		"acc": "¿No tienes una cuenta?",
		"change-lang": "Cambiar idioma",
		"email": "Correo electrónico",
		"fgt-pwd": "¿Se te olvidó tu contraseña?",
		"login": "Iniciar sesión",
		"password": "Contraseña",
		"real-time": "Con decisiones respaldadas por datos en tiempo real.",
		"scale": "Escale su operación y",
		"scale-2": "aumentar la rentabilidad",
		"signup": "Regístrate",
		"welcome": "¡Bienvenido de nuevo! Por favor, ingrese a su cuenta.",
		"zero-stress": "Sin estrés, sin complicaciones.",
    "sign-in":"Sign In"
	},
	"fr": {
		"acc": "Vous n'avez pas de compte?",
		"change-lang": "Changer de langue",
		"email": "E-mail",
		"fgt-pwd": "Mot de passe oublié?",
		"login": "S'identifier",
		"password": "Mot de passe",
		"real-time": "Avec des décisions fondées sur des données en temps réel.",
		"scale": "Faites évoluer votre opération et",
		"scale-2": "Augmenter la rentabilité",
		"signup": "S'inscrire",
		"welcome": "Nous saluons le retour! Veuillez vous connecter à votre compte.",
		"zero-stress": "Pas de stress, zéro souci.",
    "sign-in":"S'identifier"
	},
  "sw": {
		"acc": "Hauna akaunti?",
		"change-lang": "Badilisha Lugha",
		"email": "Barua pepe",
		"fgt-pwd": "Umesahau nywila?",
		"login": "Ingia",
		"password": "Nenosiri",
		"real-time": "Kwa maamuzi ya wakati halisi yanayoungwa mkono na data.",
		"scale": "Ongeza Uendeshaji wako na",
		"scale-2": "na kuongeza faida",
		"signup": "Jisajili",
		"welcome": "Karibu tena! Tafadhali ingia kwenye akaunti yako.",
		"zero-stress": "Hakuna dhiki, sifuri shida.",
        "powered-by":"Kinatumia",
        "sign-in":"Weka sahihi"
	}
}
</i18n>
